import { jsx as _jsx } from "react/jsx-runtime";
import { AuthProvider } from '@coveo/platform-client';
import defaultsDeep from 'lodash.defaultsdeep';
import { PrivilegesContext } from '../contexts/PrivilegesContext.js';
import { UserContext } from '../contexts/UserContext.js';
export var defaultTestUser = {
    username: 'tuser@coveo.com-office365',
    name: 'Test User',
    email: 'tuser@coveo.com',
    emailConfirmed: true,
    displayName: 'Test User',
    country: 'CA',
    providerUsername: 'tuser@coveo.com',
    providerUserId: '692f534e-92a2-420e-7de7-510a35646435',
    provider: AuthProvider.OFFICE365,
    realms: [],
    socialUser: true,
    expired: false,
    locked: false,
    credentialsExpired: false,
    enabled: true,
    emailAliases: [],
    additionalInformation: {},
    firstName: 'Test',
    lastName: 'User',
    lastLogin: 1737055134000,
    samlIdentityProviderId: ''
};
export var TestUserProvider = function TestUserProvider(param) {
    var children = param.children, loading = param.loading, privileges = param.privileges, user = param.user;
    var userModel = defaultsDeep({}, user, defaultTestUser);
    return loading ? null : /*#__PURE__*/ _jsx(UserContext.Provider, {
        value: {
            query: {
                data: userModel,
                isLoading: false,
                isSuccess: true,
                isPending: false,
                isError: false
            }
        },
        children: /*#__PURE__*/ _jsx(PrivilegesContext.Provider, {
            value: {
                query: {
                    data: privileges || [],
                    isLoading: false,
                    isSuccess: true,
                    isPending: false,
                    isError: false,
                    status: 'success'
                }
            },
            children: children
        })
    });
};

//# sourceMappingURL=TestUserProvider.js.map